// @ts-nocheck

// import 'bootstrap/scss/_functions.scss';
// import 'bootstrap/scss/_variables.scss';
// import 'bootstrap/scss/_mixins.scss';
// import 'bootstrap/scss/_root.scss';
// import 'bootstrap/scss/_reboot.scss';

// import 'bootstrap/dist/css/bootstrap-reboot.min.css';

import 'normalize.css';
import {ensureSessionId, Session} from "./models/Session"
import {createStore} from './store'

import 'es6-promise/auto'
import 'es6-object-assign/auto'
import 'array.prototype.find/auto'
import 'classlist-polyfill'
import 'element-closest-polyfill';

import Vue, {CreateElement, VNode} from 'vue'
import StoriesViewer from './components/Stories/StoriesViewer/StoriesViewer.vue'


import {mapState, MutationPayload} from "vuex"
/// <reference path="./bowser.d.ts" />
import bowser from 'bowser/es5'
import {debugLog, extend} from "~/common_widget/common"
import {StoriesState, STORY_LIST_TYPE} from "./store/vuex-stories-module";
import {IWidgetStoriesOptions} from "./models/WidgetStoriesOptions";
import {debug} from "~/stories_widget/util/debug";
import {setNeedSession} from "~/stories_widget/util/env";
import {ClickOnStoryInternalPayload, STORY_READER_WINDOW_REFERER, SyncStoreEvent} from "~/types";
import {SessionState} from "~/stories_widget/store/vuex-session-module";
import StoriesItem from "~/stories_widget/models/StoriesItem";
import AbstractModel from "~/stories_widget/models/AbstractModel";
import RootState from "~/stories_widget/store/rootState";
import isObject from "lodash/isObject";
import {keyCodes} from "~/stories_widget/helpers/events";

setNeedSession(true);

// import './app.scss'


// https://stackoverflow.com/questions/13815640/a-proper-wrapper-for-console-log-with-correct-line-number

const syncStore = function (mutation: MutationPayload, sharedState: RootState["shared"]) {
    if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('event', 'syncStore', {mutation});
}

const store = createStore();
const storeUnsubscribe = store.subscribe((mutation, state) => {
    if (mutation.type.substr(0, "shared".length) === "shared" && isObject(mutation.payload) && mutation.payload.__sync === undefined) {
        mutation.payload.__sync = true;
        syncStore(mutation);
    }
});

store.commit('UPDATE_NEED_SESSION', {needSession: true});

Vue.config.productionTip = false
Vue.config.performance = true

// Vue.config.devtools = true
const browser = bowser.getParser(window.navigator.userAgent);
const ua = browser.parse();

// export function debug(message?: any, ...optionalParams: any[]): void {
//   return;
// }


// window.onload = function () {

// if (window.__INITIAL_STATE__) {
// store.replaceState(window.__INITIAL_STATE__)
// }

let openOptions = STORY_READER_WINDOW_REFERER.default;

function createApp() {

    return new Vue({
        store,
        el: '#_app',
        components: {
            StoriesViewer
        },
        // data: function (){
        //   return {
        //     sharedState: store.state,
        //     showStoriesView: this.$store.state.showStoriesView,
        //     storyId: this.$store.state.storyId,
        //     saving: false,
        //     user: this.$store.state.user
        // }
        // },
        data: {

            visible: true,
            showStoriesView: false

        },
        computed: {
            ...mapState('stories', {
                sharedStoryId: (state: StoriesState): number | null => state.storyId,
                sharedShowStoriesView: (state: StoriesState): boolean => state.showStoriesView,
                modeDesktop: (state: StoriesState): boolean => state.modeDesktop
            }),
        },

        watch: {
            sharedShowStoriesView: function (to: boolean, from: boolean): void {

                if (to) {

                    this.showStoriesView = true;

                    // if ((<any>window).WStories) {
                        // TODO add temporal backdrop with loader
                        // (<any>window).WStories.switchToFullScreen();
                    // }

                    // if (!this.$store.getters['session/id']) {
                    //     Session.reInitSession().then(idSession => {});
                    // }

                    // this.showStoriesView = true;

                    try {window.focus()} catch (e) {console.error(e)}

                } else {
                    this.showStoriesView = false;
                    // if ((<any>window).WStories) {
                    //     (<any>window).WStories.switchFromFullScreen();
                    // }

                    try {window.blur()} catch (e) {console.error(e)}
                }


            },
        },
        provide: function () {
            return {
                setVisible: () => {
                    this.visible = true
                },
                setHidden: () => {
                    this.visible = false
                }
            }
        },
        mounted() {
            this.initHandlers();
        },
        destroyed() {
            storeUnsubscribe();
            this.removeHandlers();
        },
        methods: {
            initHandlers() {
                window.addEventListener('keydown', this.onKeydown);
            },
            removeHandlers() {
                window.removeEventListener('keydown', this.onKeydown);
            },
            onCloseStoryReader() {
                this.$store.commit('stories/setSharedShowStoriesView', false);

                if ((<any>window).WStoriesReader) {
                    (<any>window).WStoriesReader.close();
                }
            },
            onKeydown(e) {
                if (e.keyCode === keyCodes.esc) {
                    // this.onCloseStoryReader();
                    try {
                        this.$refs['storiesViewer'].closeViewer();
                    } catch (e) {
                        console.error(e);
                    }

                }
            },
        },
        render(h: CreateElement): VNode|undefined {
            if (this.showStoriesView) {
                return h('StoriesViewer', {
                    ref: 'storiesViewer',
                    props: {
                        id: this.sharedStoryId,
                        timeout: 10000,
                        timerEnabled: true,
                    },
                    style: {display: this.visible ? 'block' : 'none'},
                    on: {
                        close: this.onCloseStoryReader,
                        showSlide: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'showSlide', {id: event.id, index: event.index});
                        },
                        showStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'showStory', {id: event.id});
                        },
                        closeStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'closeStory', {id: event.id});
                        },
                        closeStoryByScrolling: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'closeStoryByScrolling', {id: event.id});
                        },
                        clickOnButton: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'clickOnButton', {id: event.id, index: event.index, url: event.url});
                        },
                        likeStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'likeStory', event);
                        },
                        dislikeStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'dislikeStory', event);
                        },
                        favoriteStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'favoriteStory', event);
                        },
                        favoriteStoryInternal: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'favoriteStoryInternal', event);
                        },
                        shareStory: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'shareStory', event);
                        },
                        shareStoryWithPath: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'shareStoryWithPath', event);
                        },

                        storyOpenedInternal: (event) => {
                            (<any>window).cur?.Rpc?.callMethod('event', 'storyOpenedInternal', event);
                        },
                        openViewer: (payload: {storiesId: number}) => WStoriesReader.setFixedHtmlPosition(),
                    }
                })
            } else {
                return undefined;
            }
        }
    })
}


async function mount(options: IWidgetStoriesOptions) {

    // sync
    // store.commit('shared/setOptions', {options});

    Session.setStoreLink(store);

    if ((<any>window)['app']) {
        (<any>window)['app_'] = createApp()
    }

}

function setSession(sessionData: any) {

    // if need update

    const session = AbstractModel.createInstance(Session, sessionData);


    // create model from store data

    // store.commit('session/update', session);
    //
    //
    // if (session.rawData && session.rawData.share) {
    //     store.commit('stories/setHasShare', true)
    // }
    //
    // store.commit('shared/addDefaultPlaceholders', {value: session.placeholders});

    // let session: Nullable<Session> = null;
    // try {
    //     session = await Session.init(store);
    // } catch (error) {
    //     debug(`init failed with error ${error}`)
    // }
    //
    // debug(`init success with session id ${session?.id}`)

    const fontStyle = session?.cache?.fontsCss;
    if (fontStyle) {
        initFontStyle(fontStyle);
    }

}


function initSliderMode() {

    if (ua.parsedResult.platform.type === 'mobile' || ua.parsedResult.platform.type === 'tablet') {
        store.commit('stories/DISABLE_DESKTOP_MODE');
    } else {
        store.commit('stories/ENABLE_DESKTOP_MODE');
    }


    /*      let viewportWidth = _winWidth();
          if (viewportWidth >= 768) {
              store.commit('stories/ENABLE_DESKTOP_MODE');
          } else {
              store.commit('stories/DISABLE_DESKTOP_MODE');
          }*/

}

async function initOnboarding() {

    store.dispatch('shared/FETCH_ONBOARDING_STORIES', {}).then(() => {

        const onboardingIds = store.getters['shared/onboardingStoriesIds'];

        if (onboardingIds.length > 0) {
            const id = onboardingIds[0];

            const ids: Array<number> = [];
            store.getters['shared/onboardingActiveStories'].forEach((item: StoriesItem) => {
                ids.push(item.id)
            });

            store.dispatch('stories/FETCH_STORIES_CONTEXT', ids).then(() => {
                debug('onboarding stories context loaded');
                store.dispatch('shared/FETCH_STORY', id).then((): void => {
                    store.commit('stories/SET_ACTIVE_STORY', id);
                    store.commit('shared/setStoryListType', {type: STORY_LIST_TYPE.onboarding});

                    WStoriesReader.open();
                })
                // fullScreen(document.querySelector('#app_bottom'))
            });
        }

        // this.displayedItems = this.$store.getters.activeStories
    })

}

function initFontStyle(css: string): void {
    const id = 'stories-font-style';
    let style: HTMLElement | null = document.getElementById(id);

    if (style === null) {
        style = document.createElement("style");
        (<HTMLStyleElement>style).type = 'text/css';
        style.id = id;
        style.attributes.setNamedItem(document.createAttribute('scoped'));

        if ((<any>style).styleSheet) {
            (<any>style).styleSheet.cssText = css
        } else {
            style.appendChild(document.createTextNode(css))
        }
        document.body.appendChild(style)
    } else {
        if ((<any>style).styleSheet) {
            (<any>style).styleSheet.cssText = css
        } else {
            style.textContent = '';
            style.appendChild(document.createTextNode(css))
        }
    }


}

const WStoriesReader = {

    init: function (options: IWidgetStoriesOptions) {

        options = options || {};
        (<any>window).cur.options = options;
        extend((<any>window).cur, {});

        (<any>window).cur.appTopStartMarginTop = 0;

        (<any>window).cur.RpcMethods = {
            onInit: function () {

                debug(`Widget init with options`, options);
                // debug()

                // if (cur.Rpc) cur.Rpc.callMethod('resize', 5000); // height
                // if (cur.Rpc) cur.Rpc.callMethod('switchToFullScreen');


                // addEvent(window, 'resize', onBodyResize);
                // uiScroll.addResizeSensor(cur.heightEl, WPost.onresize)[1]();
            },

            onOpenReader: async function(payload: ClickOnStoryInternalPayload) {
                // ensureSessionId();

                // console.log(payload)

                // setSession(payload.session);
                // Session.setStoreLink(store);


                const fontStyle = store.getters['shared/session']?.cache?.fontsCss;
                if (fontStyle) {
                    // TODO only on first time
                    initFontStyle(fontStyle);
                }


                store.commit('shared/setStoryListType', {type: payload.listType});

                // if (payload.items !== null && Array.isArray(payload.items)) {
                //     store.commit('shared/setStories', {models: payload.items.map(item => AbstractModel.createInstance(StoriesItem, item))});
                // }

                const ids: Array<number> = [];
                store.getters['shared/activeStories'].forEach((item: StoriesItem) => {
                    ids.push(item.id);
                });

                store.dispatch('stories/FETCH_STORIES_CONTEXT', ids).then(() => {
                    debug('stories context loaded');
                    store.dispatch('shared/FETCH_STORY', payload.id).then((): void => store.commit('stories/SET_ACTIVE_STORY', payload.id))
                    // fullScreen(document.querySelector('#app_bottom'))

                    openOptions = payload.windowReferer;
                    WStoriesReader.open(payload.windowReferer);


                });





                // const ids = [data.id];
                //
                // store.dispatch('stories/FETCH_STORIES', {}).then(() => {
                //     // this.displayedItems = this.$store.getters.activeStories
                //
                //     store.dispatch('stories/FETCH_STORIES_CONTEXT', ids).then(() => {
                //         debug('stories context loaded');
                //         store.dispatch('stories/FETCH_STORY', data.id).then((): void => store.commit('stories/SET_ACTIVE_STORY', data.id))
                //         // fullScreen(document.querySelector('#app_bottom'))
                //
                //         WStoriesReader.open();
                //
                //
                //     });
                //
                // });

            },


            onEnterFullScreen: async function (data: any) {
                const offsetTop = data.offsetTop || 0;
                if ((<any>window)['app_top']) {
                    (<any>window).cur.appTopStartMarginTop = (<any>window)['app_top'].style.getPropertyValue('margin-top');
                    (<any>window)['app_top'].style.setProperty('margin-top', offsetTop + 'px');
                }

                if ((<any>window)['_app_bottom']) {
                    (<any>window)['_app_bottom'].showStoriesView = true;

                   await ensureSessionId();

                }

            },
            onLeaveFullScreen: function () {

                // if ((<any>window)['_app_bottom']) {
                //     (<any>window)['_app_bottom'].showStoriesView = false;
                // }

            },

            onSessionInit: async function(payload) {

                // set to shared state - at least sessionId

                setSession(payload);
                Session.setStoreLink(store);


                // TODO перенести в список (менеджер)
                // await initOnboarding();

            },

            onSyncStore: function ({mutation}: SyncStoreEvent) {
                store.commit(mutation.type, mutation.payload);

                // console.log('reader onSyncStore', mutation);

            },


        };
        try {
            (<any>window).cur.Rpc = new (<any>window).fastXDM.Client((<any>window).cur.RpcMethods, {safe: true});
        } catch (e) {
            debugLog(e);
        }

        /** Detect device screen width */
        initSliderMode();
        window.addEventListener('resize', initSliderMode);

        mount(options);

    },

    switchToFullScreen: function () {
        if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('switchToFullScreen');
    },
    switchFromFullScreen: function () {
        (<any>window)['app_top'].style.setProperty('margin-top', (<any>window).cur.appTopStartMarginTop);
        if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('switchFromFullScreen');
    },
    clearLocalData: function(narrativeId?: number) {
        narrativeId = narrativeId || (<any>window).__activeNarrativeId;
        if (narrativeId) {
            sessionStorage.removeItem('narrative_' + narrativeId + '_data')
        }
    },

    setFixedHtmlPosition: function() {
        if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('setFixedHtmlPosition');
    },
    open: function (windowReferer) {
        if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('open', {windowReferer});
    },
    close: function () {
        if ((<any>window).cur.Rpc) (<any>window).cur.Rpc.callMethod('close', {windowReferer: openOptions});
    },


};


(<any>global).WStoriesReader = WStoriesReader;


// after back or load from server
// document.addEventListener('pjax:end', () => {
//   debug('dcfv')
//   mountAll()}, false)
//

// if (window['jQuery']) {
//   debug('jQuery')
//   jQuery(document).on('pjax:end', (e) => {
//     mountAll()
//   })
// }

// }


// const app = new Vue({
//   router,
//   store,
//   render: h => h(App)
// })

//
//
//
//
//
//
//
//
// import 'es6-promise/auto'
//
// import { createApp } from './app'
//
// // import './styles/main.scss';
//
// Vue.config.productionTip = false
//
//
//
// const { app, store } = createApp()
//
// // prime the store with server-initialized state.
// // the state is determined during SSR and inlined in the page markup.
// if (window.__INITIAL_STATE__) {
//   store.replaceState(window.__INITIAL_STATE__)
// }
//
// // wait until router has resolved all async before hooks
// // and async components...
// router.onReady(() => {
//   // Add router hook for handling asyncData.
//   // Doing it after initial route is resolved so that we don't double-fetch
//   // the data that we already have. Using router.beforeResolve() so that all
//   // async components are resolved.
//   router.beforeResolve((to, from, next) => {
//     const matched = router.getMatchedComponents(to)
//     const prevMatched = router.getMatchedComponents(from)
//     let diffed = false
//     const activated = matched.filter((c, i) => {
//       return diffed || (diffed = (prevMatched[i] !== c))
//     })
//     const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)
//     if (!asyncDataHooks.length) {
//       return next()
//     }
//
//     bar.start()
//     Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
//       .then(() => {
//         bar.finish()
//         next()
//       })
//       .catch(next)
//   })
//
//   // actually mount to DOM
//   app.$mount('#app')
// })
//
// // service worker
// // if ('https:' === location.protocol && navigator.serviceWorker) {
// //   navigator.serviceWorker.register('/service-worker.js')
// // }
